export default function PesquisarOrdemCompra(){
    return (
        "Pesquisar Ordem de Compra"
    );
}